import { render, staticRenderFns } from "./winners.vue?vue&type=template&id=26d11844&"
import script from "./winners.ts?vue&type=script&lang=ts&"
export * from "./winners.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports